module.exports = __webpack_public_path__ + "static/media/021.f64e4369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/021.jpg
// module id = 368
// module chunks = 0